import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  updateSkillVariables,
  getSession,
  executeFlow,
} from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snack";
import infoIcon from "../../../../../../../images/info-new.png";
import $ from "jquery";
import {
  desktopAgentExists,
  sendMessageToExtension,
} from "../../../../../../../utility/extension";
import Zoom from "react-medium-image-zoom";
import { Store } from "react-notifications-component";

const PlayModalWebAuto = () => {
  const dispatch = useDispatch();
  const skill = useSelector((state) => state.skillReducer);
  const userDeviceId = useSelector((state) => state.skillReducer.draftSession);

  const varData = skill?.trainDraft?.FORMATED_DATA?.variables;

  const history = useHistory();
  const [isLoadingNewVar, setIsLoadingNewVar] = useState(false);

  const resetVarData = () => {
    history.push(window.location.pathname);
  };

  const runFlow = async (shouldRestoreData) => {
    setIsLoadingNewVar(true);
    let payload = {};
    // const deviceId = await dispatch(getSession());
    // console.log(deviceId, "gdg");
    let form = $("#editVariables");
    let _formData = form.serializeArray();
    _formData.forEach((i) => (payload[i.name] = i.value));

    let data = {
      deviceId: userDeviceId,
      skillId: skill?.trainDraft?.id,
      variables: payload,
      bulk: true,
      restoreChrome: shouldRestoreData,
    };
    const flowResponse = await dispatch(executeFlow(data));
    if (!flowResponse) {
      setIsLoadingNewVar(false);
    }
  };

  const notificationPopUp = () => {
    Store.addNotification({
      title: "Note: ",
      message:
        "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
      type: "warning",
      insert: "top",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    window.setTimeout(function () {
      window.open(
        `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
        "_blank"
      );
    }, 5000);
  };
  const getExecutionRequirements = async () => {
    try {
      let _checkForExtension = await sendMessageToExtension({ type: "ping" });
      let _checkDesktopAgent = await desktopAgentExists();
      if (_checkDesktopAgent.desktopAgentExists) {
        window.jQuery("#alertModal1").modal({ show: true });
      } else {
        runFlow(true);
      }
    } catch (err) {
      notificationPopUp();
    }
  };

  return (
    <div>
      <div
        className="modal crt-skill fade"
        id="myWebAutomationPlayModal"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content crt-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() => {
                  resetVarData();
                }}
              >
                &times;
              </button>
              <h4 className="modal-title text-center">Review Data </h4>
            </div>
            <div className="modal-body">
              <form id="editVariables" className="form-contain editVariables">
                {varData &&
                  Object.values(varData)
                    .sort((a, b) => a.number - b.number)
                    .filter((i) => i.reviewVariable == true)
                    .map((data, index) => (
                      <div
                        className="frm-block md-flex-input review-data"
                        key={index}
                      >
                        <div className="label-info-btn">
                          <label>{data.name}</label>
                          <button
                            className="btn-link dm-info fixed-info"
                            type="button"
                            data-toggle="dropdown"
                          >
                            <img src={infoIcon} alt="" />
                            <div className="popup-img modal-review-img">
                              <Zoom>
                                <img
                                  alt=""
                                  src={
                                    skill?.trainDraft?.FORMATED_DATA?.actions[
                                      data.id
                                    ]?.pageScreenshot
                                  }
                                />
                              </Zoom>
                            </div>
                          </button>
                        </div>
                        <div className="ip-tl-label">
                          <span className="tl-label" for={data.id}>
                            {data?.label}
                            {/* {data.name} */}
                          </span>

                          <input
                            type="text"
                            id={index}
                            name={data.name}
                            defaultValue={data.defaultValue}
                          ></input>
                        </div>
                      </div>
                    ))}
                <div className="frm-btns">
                  <button
                    className="btn-outline"
                    data-dismiss="modal"
                    onClick={() => {
                      resetVarData();
                    }}
                  >
                    Ignore
                  </button>
                  {isLoadingNewVar ? (
                    <button className="primary-btn">
                      <div class="sp sp-circle text-light"></div>
                    </button>
                  ) : (
                    <span
                      className="primary-btn"
                      onClick={() => getExecutionRequirements()}
                      data-dismiss="modal"
                    >
                      Submit
                    </span>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        id="alertModal1"
        class="modal fade crt-skill alert-modal"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog">
          <div class="modal-content crt-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <h4 class="modal-title">Supervity Says:</h4>
            </div>
            <div class="modal-body">
              <form class="form-contain" action="javascript:void(0)">
                <div class="frm-block alert-text">
                  <p>
                    Click <strong>'OK'</strong> to execute the skill in normal
                    window (Will restore browser if needed). So make sure to
                    save the unsaved data if any.
                  </p>
                  <p>
                    Click <strong>'Cancel'</strong> to execute skill in new
                    incognito window.
                  </p>
                </div>
                <div class="frm-btns">
                  <button
                    class="btn-outline"
                    data-dismiss="modal"
                    onClick={() => runFlow(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-primary"
                    data-dismiss="modal"
                    onClick={() => {
                      runFlow(true);
                    }}
                  >
                    OK
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayModalWebAuto;
